<template>
  <div>
    <div class="footer">
      <div class="message">
        <div>
          <p>
            Regulator：Chinese Academy of Social Sciences (CASS)    Host：Institute of
            Economics, CASS
          </p>
          <p>
            Sponsored by the National Social Science Fund of China (NSSFC)    Free of Page
            Charge
          </p>
          <p>
            Opinions expressed by the authors on this website do not represent the views
            of the Economic Research Journal and its website.
          </p>
          <p>
            International Standard Serial Number：ISSN 0577-9154    Domestic Unified
            Serial Number：CN1-1081/F
          </p>
          <p>Domestic Mailing Code：2-251    Foreign Code：M16</p>
          <p>
            Address：No. 2, Yuetanbeixiaojie, Xicheng District, Beijing, P. R. China
               Postal Code：100836    Tel/Fax：+8610-68034153
          </p>
          <p>
            Copyright 2010-2025. All rights reserved by the Economic Research
            Journal website.
          </p>
          <div class="btm">
            <a href="https://beian.miit.gov.cn/" style="text-decoration: none"
              >京ICP备 10211437号</a
            >
          </div>
        </div>
      </div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="less" scoped>
.footer {
  min-width: 1280px;
  padding: 60px 0 100px;
  background-color: #003f97;
  color: #fff;
  .message {
    display: flex;
    align-items: center;
    justify-content: center;
    > div:first-of-type {
      position: relative;
      p {
        font-family: PingFangSC, PingFang SC;
        font-size: 14px;
        color: #ffffff;
        line-height: 36px;
        text-align: center;
        font-style: normal;
      }
    }
    > div:last-of-type {
      p {
        // margin-top: 20px;
        color: #fff;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 36px;
        text-align: center;
        font-style: normal;
      }
    }
  }
  .line {
    margin-top: 30px;
    border-bottom: 1px dashed #979797;
    opacity: 0.6;
  }
}

.btm {
  position: absolute;
  margin-top: 20px;
  height: 25px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  font-size: 14px;
  color: #fcfdff;
  line-height: 25px;
  text-align: center;
  font-style: normal;
  left: 50%;
  transform: translateX(-50%);
  bottom: -87px;

  a {
    color: #fcfdff;
    cursor: pointer;
  }
}
</style>
